import { red } from "@material-ui/core/colors"
import { createMuiTheme } from "@material-ui/core/styles"

declare module "@material-ui/core/styles/createPalette" {
  interface Palette {
    appContainerBackground: string
  }

  interface PaletteOptions {
    appContainerBackground?: string
  }
}

const circuPayTheme = createMuiTheme({
  typography: {
    fontFamily: [
      "Gilroy",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  palette: {
    primary: {
      main: "#4AA3A8", // Teal Blue (Arc)
      dark: "#3A8A8E",
    },
    secondary: {
      main: "#0B4EA2", // Blue (Growth Bar)
      dark: "#083A78",
      light: "#E6EEFA",
    },
    error: {
      main: "#9B1C1F", // Deep Red (Checkmark)
    },
    warning: {
      main: "#A85A1F", // Burnt Orange (Growth Bar)
    },
    info: {
      main: "#C8B37E", // Beige / Gold (Growth Bar)
    },
    background: {
      default: "#FFFFFF",
    },
    text: {
      primary: "#000000", // Black (Text)
      secondary: "#000000",
    },
    appContainerBackground: "#FFFFFF",
  },
  overrides: {
    MuiButton: {
      contained: {
        borderRadius: "1px",
        padding: "15px",
        textTransform: "none",
        fontWeight: "bold",
        fontSize: "12pt",
        width: "200px",
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none",
        },
      },
      text: {
        textTransform: "none",
        fontWeight: "bold",
        fontSize: "12pt",
      },
    },
  },
})

export default circuPayTheme
